import a from"./array-iteration.js";import t from"./array-method-is-strict.js";var o=a.forEach,e=t,f=e("forEach"),h=f?[].forEach:function(r){return o(this,r,arguments.length>1?arguments[1]:void 0)};export{h as default};
